import { PromoModalDetails } from 'blocks/Pricing/types';
import { MAIL_TO_SUPPORT_LINK } from 'utils/constants';

export const PRO_TRIAL_DETAILS: PromoModalDetails = {
  title: 'Sorry, this promo is unavailable',
  description:
    'The promotion that you tried to activate is not available for your account, but please contact support if you believe this is an error.',
  cta: 'got it',
};

export const COUPON_DETAILS: PromoModalDetails = {
  title: 'Sorry, BOGO is unavailable',
  description: `BOGO is not available for your account. If you have questions or believe this is an error, please contact support by emailing ${MAIL_TO_SUPPORT_LINK}.`,
  cta: 'continue to headliner',
};
